import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Link,
  Box,
  Typography,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Call, Menu } from "@mui/icons-material";
import { LOGO } from "../../../assets/images";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const Header = () => {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigationData = [
    {
      name: "Home",
      link: "/home",
    },
    {
      name: "Services",
      link: "/services",
    },
    {
      name: "Appointment",
      link: "/appoinments",
    },
    {
      name: "AIMm Team",
      link: "/teams",
    },
    {
      name: "AIMm Blog",
      link: "/aimm-blog",
    },
    {
      name: "AIMm Store",
      link: "/AIMm Store",
    },
    {
      name: "Client Portal",
      link: "/client-portal",
    },
  ];

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <AppBar
          position="absolute"
          sx={{
            backgroundColor: "white",
            boxShadow: 1,
            borderRadius: "24px",
            mt: 2,
            boxShadow: 5,
            zIndex: 1,
            width: {
              md: "100%",
              xs: "100%",
              xl: "100%",
              lg: "100%"
            },
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: {
                md : "8px 24px",
                xs: "8px 8px"
              },
              alignItems: "center",
            }}
          >
            <Box
              onClick={() => {
                navigate("/home")
              }
              }
              sx={{
                display: "flex",
                alignItems: "center",
                width: {
                  md: 'auto',
                  lg: "36%",
                  xs: "auto"
                },
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={LOGO}
                alt="AIM microBiome"
                sx={{
                  height: {
                    md: 50,
                    xs: 50,
                  }, marginRight: {
                    md: 1, xs: .5
                  }
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "primary.main",
                    fontSize: {
                      md: "20px",
                      xs: "20px"
                    },
                    fontFamily: 'Poppins'
                  }}
                >
                  AIM microBiome
                </Typography>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: {
                      md: "10px",
                      xs: "10px"
                    },
                    fontWeight: 500,
                    marginLeft: 1,
                    mt: -0.4,
                    fontFamily: 'Poppins',
                    display:{
                      md: "none",
                      xs: "none"
                    }
                  }}
                >
                  Gut Health, Whole Health
                </Typography>
              </Box>
            </Box>

            {isMobile ? (
              <Box>
                <IconButton
                  sx={{
                    backgroundColor: "primary.main",
                    mr: 1,
                    "&:hover": {
                      backgroundColor: "primary.main",
                    },
                    '&:active': {
                      backgroundColor: "primary.main",
                    },
                    "&:focus": {
                      backgroundColor: "primary.main",
                    },
                  }}
                  onClick={() => navigate("/contact-us")}
                >
                  <Call sx={{
                    color: "white",
                    cursor: "pointer",
                    fontSize: "small",
                  }} />
                </IconButton>
                {/* <IconButton
                  sx={{
                    backgroundColor: "primary.main",
                    "&:hover": {
                      backgroundColor: "primary.main",
                    },
                    '&:active': {
                      backgroundColor: "primary.main",
                    },
                    "&:focus": {
                      backgroundColor: "primary.main",
                    },

                  }}
                  onClick={() => navigate("/cart")}
                >
                  <ShoppingCartIcon sx={{
                    color: "white",
                    cursor: "pointer",
                    fontSize: "small",
                  }} />
                </IconButton> */}

                <IconButton
                  sx={{
                    color: "primary.main",
                  }}
                  onClick={() => setDrawerOpen(true)}
                >
                  <Menu sx={{
                    height: "30px",
                    color: "text.main",
                  }} />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                >
                  <List>
                    {navigationData.map((item) => (
                      <ListItem
                        button
                        key={item.name}
                        component={Link}
                        to={item.link}
                        onClick={() => {
                          if (item.name === "Appointment") {
                            window.open("https://aimmicrobiome.practicebetter.io/#/67b154d6926207b7c4e8528a/bookings?step=services", "_blank");
                            setDrawerOpen(false);
                          } else if (item.name === "Client Portal") {
                            window.open("https://aimmicrobiome.practicebetter.io/#/signin", "_blank");
                          } else if (item.name === "AIMm Store") {
                            window.open("https://us.fullscript.com/welcome/smirza1741548876", "_blank");
                          } else {
                            navigate(item.link);
                            setDrawerOpen(false);
                          }
                        }}
                        
                      >
                        <ListItemText primary={item.name} />
                      </ListItem>
                    ))}
                    <ListItem>
                      <Button
                        onClick={() => {
                          navigate("/contact-us")
                          setDrawerOpen(false)
                        }}
                        variant="contained"
                        startIcon={<Call />}
                        fullWidth
                      >
                        Contact Us
                      </Button>
                    </ListItem>
                  </List>
                </Drawer>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  alignItems: "center"
                }}
              >
                <Box sx={{ display: "flex", gap: {
                  md: 2, xs: 0
                }, width: "85%", justifyContent: "end", alignItems: "center", }}>
                  {navigationData.map((item) => (
                    <Typography
                      key={item.name}
                      onClick={() => {
                        if (item.name === "Appointment") {
                          window.open("https://aimmicrobiome.practicebetter.io/#/67b154d6926207b7c4e8528a/bookings?step=services", "_blank");
                          setDrawerOpen(false);
                        } else if (item.name === "Client Portal") {
                          window.open("https://aimmicrobiome.practicebetter.io/#/signin", "_blank");
                        } else if (item.name === "AIMm Store") {
                          window.open("https://us.fullscript.com/welcome/smirza1741548876", "_blank");
                        } else {
                          navigate(item.link);
                          setDrawerOpen(false);
                        }
                      }}
                      sx={{
                        textTransform: "none",
                        color:
                          location.pathname === item.link
                            ? "primary.main"
                            : "text.main",
                        fontWeight:
                          location.pathname === item.link ? "700" : "500",
                        fontSize: "15px",
                        "&:hover": { textDecoration: "underline" },
                        fontFamily: "Poppins",
                        mr:{
                          md: 3,xs:0
                        },
                        cursor: "pointer"
                      }}
                    >
                      {item.name}
                    </Typography>
                  ))}
                </Box>
                <Box sx={{ width: "15%" }}>
                  <Button onClick={() => {
                    navigate("/contact-us")
                  }} variant="contained" sx={{
                    height: "48px",
                    fontFamily: "Poppins",
                    fontSize: "1rem"
                  }} startIcon={<Call />}>
                    Contact Us
                  </Button>
                </Box>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </Box>
    </Container>
  );
};

export default Header;
